import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LoginPage } from 'components/auth/LoginPage/LoginPage'
import { IconStyleSheet } from 'components/common/Icon'
import { InterviewApp } from 'components/modules/interview/InterviewApp'
import { TemplatesCreator } from 'components/modules/creators/TemplatesCreator/TemplatesCreator'
import { Report } from 'components/pages/Report/Report'
import { Template } from 'components/pages/InterviewTamplate/Template'
import { Snackbar } from 'components/shared/Snackbar/Snackbar'
import { Translate } from 'utils/translate'
import CandidateApp from './CandidateApp'
import { DashboardApp } from './DashboardApp'

import { getLanguage, requestUser } from 'ducks/auth'
import {
  useLocation,
  PERSONALITY_QUIZ,
  INTEREST_QUIZ,
  CANDIDATE_REPORT,
  EXTERNAL_CANDIDATE_REPORT,
  INTERVIEW_TEMPLATE,
  INTERVIEW,
  QUIZ_MAIN,
  QUIZ_TERMS,
  GMA_QUIZ,
  GMA_QUIZ_GUIDE,
  GMA_QUIZ_WELCOME,
  NOT_FOUND,
  TEMPLATES_CREATOR,
} from 'ducks/router'
import { useSnackbar } from 'hooks'

import './App.scss'

const NotFound = () => {
  if (!window.location.pathname.endsWith('/')) {
    // Add trailing slash. Might be a mistyped django route
    window.location.replace(window.location.pathname + '/')
    return null
  }
  return <div>Page not Found</div>
}

const Switcher = () => {
  const language = useSelector(getLanguage)
  const { type, pathname = '' } = useLocation()

  if (pathname.match(/^\/auth/)) {
    return (
      <Translate {...{ language }}>
        <LoginPage />
      </Translate>
    )
  }

  switch (type) {
    case NOT_FOUND:
      return <NotFound />
    case CANDIDATE_REPORT:
      return <Report />
    case EXTERNAL_CANDIDATE_REPORT:
      return <Report isCandidate />
    case INTERVIEW_TEMPLATE:
      return <Template />
    case QUIZ_MAIN:
    case QUIZ_TERMS:
    case GMA_QUIZ:
    case GMA_QUIZ_GUIDE:
    case GMA_QUIZ_WELCOME:
    case PERSONALITY_QUIZ:
    case INTEREST_QUIZ:
      return <CandidateApp />
    case INTERVIEW:
      return (
        <Translate {...{ language }}>
          <InterviewApp />
        </Translate>
      )
    case TEMPLATES_CREATOR:
      return <TemplatesCreator />

    default:
      return (
        <Translate {...{ language }}>
          <DashboardApp />
        </Translate>
      )
  }
}

const App = () => {
  const dispatch = useDispatch()

  const {
    state: { snacks },
    handlers: { handleHideSnackbar },
  } = useSnackbar()

  // TODO: rewrite routing to properly handle
  // authentication for all the routes
  React.useEffect(() => {
    dispatch(requestUser())
  }, [dispatch])

  return (
    <>
      <Switcher />
      <Snackbar onDismiss={handleHideSnackbar} {...{ snacks }} />
      <IconStyleSheet />
    </>
  )
}

export default App
